module.exports = __webpack_public_path__ + "static/img/3.3284529.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/honor/3.png
// module id = ynuh
// module chunks = 1